import { render, staticRenderFns } from "./TotalOrderNumber.vue?vue&type=template&id=5826be78&scoped=true&"
import script from "./TotalOrderNumber.vue?vue&type=script&lang=ts&"
export * from "./TotalOrderNumber.vue?vue&type=script&lang=ts&"
import style0 from "./TotalOrderNumber.vue?vue&type=style&index=0&id=5826be78&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5826be78",
  null
  
)

export default component.exports